'use client';

import dynamic from 'next/dynamic';

/**
 * `lottie-react` (and the lottie-web player behind it) loaded on demand.
 *
 * Every Lottie surface in the app only draws after mount — the server renders
 * the sized container and nothing inside — so deferring the runtime changes
 * nothing visually, while keeping ~250 KB of player code out of the shared
 * bundle that every page ships. Use this in place of `import Lottie from
 * 'lottie-react'`; the props (including `lottieRef`) are the same.
 */
export const LazyLottie = dynamic(() => import('lottie-react'), { ssr: false });
